var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivirod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 707.91 179.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.09,128.69q2.85-4.18,5.79-8.28l11.73-16.57L96.41,74,126,120.41l-11.88,83.43-74.49-43.4a.21.21,0,0,0,.07-.15A348.91,348.91,0,0,1,59.09,128.69Z",
    transform: "translate(-31.46 -72.81)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.18,200.39a52.15,52.15,0,0,1-.44-14.07,62.08,62.08,0,0,1,1.68-9.61l77.65,46.63,14.59,22.52q-11.8,6.13-29.84,6.89H92.37a71.09,71.09,0,0,1-15.46-2.64,63.92,63.92,0,0,1-20.32-9.68A70.78,70.78,0,0,1,43.4,227.82l-1.62-2.06a58,58,0,0,1-5.86-11.36A73.7,73.7,0,0,1,32.18,200.39Z",
    transform: "translate(-31.46 -72.81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.59,135.36c.93,1.32,1.83,2.67,2.71,4a193,193,0,0,1,17.52,33.51q3.59,8.94,2.72,22-1,14.29-6.75,24.48a68.27,68.27,0,0,1-12.18,15.69l-15.17-18.25Z",
    transform: "translate(-31.46 -72.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.53,181.92q0-28.83,10.78-43.94t31-15.11q17.88,0,27.91,14.53V72.81h20.42V250H252.92l-1-13.38q-10,15.69-28.72,15.69-19.38,0-30.4-15.06t-11.24-42.5Zm20.41,11.58q0,21,6.23,30.82t20.3,9.85q15.22,0,22.72-15.32V156q-7.84-15-22.6-15-14.09,0-20.3,9.85t-6.35,30.24Z",
    transform: "translate(-31.46 -72.81)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.83,92.07a13.07,13.07,0,0,1-2.88,8.65q-2.9,3.47-8.77,3.46t-8.65-3.46a13.07,13.07,0,0,1-2.88-8.65,13.55,13.55,0,0,1,2.88-8.77q2.88-3.57,8.65-3.57t8.71,3.63A13.42,13.42,0,0,1,318.83,92.07ZM317.22,250H296.8V125.17h20.42Z",
    transform: "translate(-31.46 -72.81)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.89,218.94l23.65-93.77H421.3l-37,124.8H369.05l-37.48-124.8h20.76Z",
    transform: "translate(-31.46 -72.81)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.37,92.07a13.07,13.07,0,0,1-2.88,8.65q-2.88,3.47-8.77,3.46t-8.65-3.46a13.07,13.07,0,0,1-2.88-8.65,13.55,13.55,0,0,1,2.88-8.77q2.88-3.57,8.65-3.57t8.71,3.63A13.42,13.42,0,0,1,458.37,92.07ZM456.76,250H436.34V125.17h20.42Z",
    transform: "translate(-31.46 -72.81)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M532.58,144.32a49.44,49.44,0,0,0-9.22-.81q-15.69,0-21.92,17.19V250H481V125.17h19.84l.34,12.69q8.19-15,23.18-15a18,18,0,0,1,8.08,1.61Z",
    transform: "translate(-31.46 -72.81)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M538.51,181.8q0-27.21,13.21-43.08t34.89-15.85q21.69,0,34.89,15.45t13.55,42.1v13.15q0,27.1-13.15,42.9t-35.06,15.81q-21.69,0-34.77-15.34t-13.56-41.53Zm20.42,11.77q0,19.26,7.55,30.28t20.36,11q27,0,27.8-39V181.8q0-19.14-7.61-30.27T586.61,140.4q-12.57,0-20.13,11.13t-7.55,30.16Z",
    transform: "translate(-31.46 -72.81)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M649.29,181.92q0-28.83,10.78-43.94t31-15.11q17.88,0,27.91,14.53V72.81h20.42V250H720.68l-1-13.38q-10,15.69-28.72,15.69-19.38,0-30.4-15.06t-11.24-42.5ZM669.7,193.5q0,21,6.23,30.82t20.3,9.85q15.22,0,22.72-15.32V156q-7.85-15-22.6-15-14.07,0-20.3,9.85t-6.35,30.24Z",
    transform: "translate(-31.46 -72.81)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivirod);
export default __webpack_public_path__ + "static/media/divirod.1e981ecb5b364add8fadb1691966dfd7.svg";
export { ForwardRef as ReactComponent };